var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0002 22H4.00019C3.46427 22.0186 2.94467 21.8139 2.56548 21.4347C2.1863 21.0555 1.98157 20.5359 2.00019 20V10C1.98157 9.46408 2.1863 8.94448 2.56548 8.5653C2.94467 8.18611 3.46427 7.98138 4.00019 8.00001H8.00019V4.00001C7.98157 3.46408 8.1863 2.94448 8.56548 2.5653C8.94467 2.18611 9.46427 1.98138 10.0002 2.00001H20.0002C20.5361 1.98138 21.0557 2.18611 21.4349 2.5653C21.8141 2.94448 22.0188 3.46408 22.0002 4.00001V14C22.0185 14.5358 21.8137 15.0553 21.4346 15.4344C21.0555 15.8135 20.536 16.0183 20.0002 16H16.0002V20C16.0185 20.5358 15.8137 21.0553 15.4346 21.4344C15.0555 21.8135 14.536 22.0183 14.0002 22ZM4.00019 10V20H14.0002V16H10.0002C9.46435 16.0183 8.94493 15.8135 8.56581 15.4344C8.18669 15.0553 7.98187 14.5358 8.00019 14V10H4.00019ZM10.0002 4.00001V14H20.0002V4.00001H10.0002Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy2);
export default __webpack_public_path__ + "static/media/copy2.0ebb7b6020228e8d10673fa75452190f.svg";
export { ForwardRef as ReactComponent };